import React from 'react';

import { defineMessages, useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import { Flex } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { AudioStreamingState, setAudioPlayerStreamingStore } from '../../state/AudioPlayerStreamingStore';
import { UnauthorizedAccessIcon } from '../assets/icons/UnauthorizedAccessIcon';

const i18n = defineMessages({
	unauthorizedAccessMessage: {
		id: 'ai-audio.player.unauthorized-access-message',
		defaultMessage: 'You do not have permission to play this audio.',
		description: 'Message shown when user lacks authorization to access audio content',
	},
	closeButtonLabel: {
		id: 'ai-audio.player.unauthorized-access-close-button-label',
		defaultMessage: 'Close',
		description: 'Label for the close button in unauthorized access error',
	},
});

const styles = cssMap({
	container: {
		flex: 1,
		alignItems: 'center',
		justifyContent: 'center',
		textAlign: 'center',
		paddingTop: token('space.800'),
		paddingRight: token('space.400'),
		paddingBottom: token('space.1000'),
		paddingLeft: token('space.400'),
		flexGrow: 1,
	},
});

export const UnauthorizedAccessError = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	const handleClose = () => {
		setAudioPlayerStreamingStore({
			type: AudioStreamingState.UNINITIALIZED,
		});
	};

	return (
		<Flex
			xcss={styles.container}
			justifyContent="center"
			alignItems="center"
			rowGap="space.200"
			direction="column"
		>
			<UnauthorizedAccessIcon/>
			<Heading size="small" as="h3">
				{formatMessage(i18n.unauthorizedAccessMessage)}
			</Heading>
			<Button appearance="default" onClick={handleClose}>
				{formatMessage(i18n.closeButtonLabel)}
			</Button>
		</Flex>
	);
};
